import { render, staticRenderFns } from "./MainMatchStatsPlayer.vue?vue&type=template&id=8f81713e&scoped=true&"
import script from "./MainMatchStatsPlayer.vue?vue&type=script&lang=js&"
export * from "./MainMatchStatsPlayer.vue?vue&type=script&lang=js&"
import style0 from "./MainMatchStatsPlayer.vue?vue&type=style&index=0&id=8f81713e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f81713e",
  null
  
)

export default component.exports